<p-fluid>
  <div
    [class.xofmanyrequired]="xOfManyErrors() && isOneOfManyRequired()"
    class="w-100"
  >
    <p-multiSelect
      #lotSelection="ngModel"
      name="lotSelection"
      [options]="lotOptions"
      [required]="required()"
      [(ngModel)]="selectedLots"
      (onPanelHide)="onChange()"
      resetFilterOnHide="true"
      [placeholder]="label"
      [selectionLimit]="selectionLimit()"
      selectedItemsLabel="{0} items selected"
      [maxSelectedLabels]="maxSelectedLabels()"
      [showToggleAll]="showToggleAll()"
      [appendTo]="appendTo()"
      [disabled]="disabled"
    >
      @if (overrideHeader) {
        <p-header>
          <div class="pb-2">
            @if (showClearSelectionsButton()) {
              <p-button
                type="button"
                label="Clear Selections"
                severity="secondary"
                size="small"
                class="float-right ml-2 mr-2"
                [disabled]="!(selectedLots | hasValue)"
                (onClick)="clearSelectedLots()"
              />
            }
            @if (showIncludeElevationSwitch()) {
              <i class="float-right">Append Elevation </i>
            }
            @if (showIncludeElevationSwitch()) {
              <p-checkbox
                [binary]="true"
                styleClass="float-right"
                name="includePlanElevation"
                [(ngModel)]="includeElevation"
                (onChange)="onIncludeElevationChange()"
                [disabled]="includeElevationSwitchDisabled()"
              />
            }
          </div>
        </p-header>
      }
    </p-multiSelect>
  </div>
  <error-message [errorControl]="lotSelection">
    @if (lotSelection?.errors?.required) {
      <span>Please select at least one lot to continue.</span>
    }
  </error-message>
</p-fluid>
